import { FC } from 'react';
import Input from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import './phoneInput.scss';

export interface ICountry {
  countryCode?: string;
}

export interface IPhoneInput {
  isError: boolean;

  phoneNumber: string;

  onChange(phoneNumber: string, country: ICountry): void;
}

export const PhoneInput: FC<IPhoneInput> = ({ isError, phoneNumber, onChange }) => {
  return (
    <Input
      country="us"
      specialLabel="Phone Number"
      inputClass="phone-input"
      containerClass="phone-input-container"
      value={phoneNumber}
      enableLongNumbers
      isValid={!isError}
      inputProps={{ name: 'number' }}
      onChange={onChange}
    />
  );
};
